import {
  SET_NOW_SELECT_UUID,
  SET_CONFIG_STATE,
  TRIGGER_INIT_PAGE_FUN,
  SET_LOADING
} from '../mutation-types'
import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'
const state = {
  selectUUID: '',
  triggerInitPageIndex: 0, // 中间页、跳板页 初始化页面数据
  sessionAlertIndex: 0, // 触发 session 超时弹窗的 隐藏显示
  sessionAlertShow: false, // session 超时弹窗 是否显示
  noUsablePackageAlertShow: false,
  previewFileChange: 0, // 深度预览文件变化时
  loading: {
    content: false,
    contentBox: false // content-box 区域loading
  },
  permissionMajor: { // 普通员工 登录后 将有审核权限的专业 暂存在store中
    inventory: {}, // 有审核权限的 清单专业 对象的key为专业ID
    quota: {}, // 有审核权限的 定额专业
    combination: {}, // 有审核权限的 组价专业
    material: false // 有人材机数据的审核权限
  }
}

const mutations = {
  // 1. 将当前正在操作的 多选下拉框 的UUID 放到store中
  [SET_NOW_SELECT_UUID] (state, val) {
    state.selectUUID = val
  },
  // 2.
  [TRIGGER_INIT_PAGE_FUN] (state) {
    console.log('2222222222222222')
    if (!state.triggerInitPageIndex) {
      state.triggerInitPageIndex++
    }
  },
  //
  [SET_CONFIG_STATE] (state, val) {
    if (val && typeOf(val) === 'Object') {
      for (const key in val) {
        switch (key) {
          case 'previewFileChange':
            state.previewFileChange++
            break
          case 'permissionMajor':
            for (const key in state.permissionMajor) {
              if (key in val) {
                if (key !== 'material') {
                  state.permissionMajor[key] = val[key] || {}
                } else {
                  state.permissionMajor[key] = val[key] || false
                }
              }
            }
            break
          default:
            state[key] = val[key]
            if (key === 'sessionAlertShow') {
              state.sessionAlertIndex++
            }
        }
      }
    }
  },
  // 设置全局loading
  [SET_LOADING] (state, {key, value}) {
    if (key in state.loading) {
      state.loading[key] = value || false
    }
  }
}

const actions = {
  setLoading ({commit}, obj) {
    commit(SET_LOADING, obj)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
